const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://digitalmarketsquareapi.vercel.app/api/v1"
    : "http://localhost:4000/api/v1";

const SITE_URL =
  process.env.NODE_ENV === "production"
    ? "https://digitalmarketsquare.com"
    : "http://localhost:3000";

const credentials = {
  appName: "Digital Marketsquare",
  appShortDesc: "Monetize Your Social Presence",
  email: "digitalmarketsquare.com@gmail.com",
  BASE_URL: API_BASE_URL,
  SITE_URL,
  assetImage_URL: `${API_BASE_URL}/assets/image/view`,
  categoryImage_URL: `${API_BASE_URL}/category/image/view`,
};

export default credentials;
